export class ExistingDraftClaimRequest {
    public sponsorId: number;
    public policyId: number;
    public emailId: string;
    public customerId: number;
  }
